const SECOND_IN_MS = 1000;
const DAY_IN_MS = 86400000;
const MONTH_IN_MS = 30 * DAY_IN_MS;
const YEAR_IN_MS = 365 * DAY_IN_MS;

/** Cookie to store temporarily UTM params for the user */

export const COOKIE_UTM = 'sessionUtm';
export const COOKIE_USER_ID = 'userIdCookie';
export const COOKIE_USER_TOKEN = 'userTokenCookie';
export const COOKIE_BROWSER_ID = 'browserIdCookie';
export const COOKIE_USER_GROUP = 'userGroup';
/** Expiry time for the auth cookie in milliseconds */
export const COOKIE_EXPIRY_AUTH = DAY_IN_MS;

/** Expiry time for the tracking cookie in milliseconds */
export const COOKIE_EXPIRY_TRACKING = YEAR_IN_MS;

/** Cookie for recently viewed cars */
export const COOKIE_RECENTLY_VIEWED = 'recentlyViewedCars';
export const COOKIE_EXPIRY_RECENTLY_VIEWED = MONTH_IN_MS;

/** Cookie to store the trade-in enquiry data */
export const COOKIE_TRADE_IN_ENQUIRY = 'tradeInEnquiry';
/** Cookie to store the trade-in glass vehicle data */
export const COOKIE_TRADE_IN_VEHICLE_DATA = 'tradeInVehicleData';
export const COOKIE_EXPIRY_TRADE_IN_ENQUIRY = DAY_IN_MS;

/** Cookie to store the inspection booking data */
export const COOKIE_BOOKING_FORM = 'bookingForm';

/** Cookie to track booking submission type (expires quickly) */
export const COOKIE_BOOKING_SUBMISSION_TYPE = 'bookingSubmissionType';
export const COOKIE_EXPIRY_BOOKING_SUBMISSION_TYPE = 10 * SECOND_IN_MS; // 10 seconds

/** Cookie to store the auth form data */
export const COOKIE_AUTH_FORM = 'authFormData';
export const COOKIE_EXPIRY_AUTH_FORM = DAY_IN_MS;

/** Cookie to track if user started a chat from a greeting */
export const COOKIE_CHAT_STARTED_FROM_GREETING = 'chatStartedFromGreeting';
export const COOKIE_EXPIRY_CHAT_STARTED_FROM_GREETING = MONTH_IN_MS; // 30 days

/** Cookie storing the encoded NRMA membership ID from the nrma_token query param */
export const COOKIE_NRMA_TOKEN = 'nrma_token';
export const COOKIE_EXPIRY_NRMA = 7 * DAY_IN_MS;

/** Cookie set when user has seen the NRMA perks popup (cleared when nrma_token is set so new sessions get the popup). Expires in 7 days. */
export const COOKIE_NRMA_PERKS_DISMISSED = 'nrma_perks_dismissed';
export const COOKIE_EXPIRY_NRMA_PERKS_DISMISSED = COOKIE_EXPIRY_NRMA;
